import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad2CBlueBBlue = () => <CrossRoad coords="1323.000000, 839.000000"/>;
export default CrossRoad2CBlueBBlue;
